package one.healthium.profile.ui.update_age

import one.healthium.domain.user.UserModel

internal data class UpdateAgeUiState(
    val loading: Boolean = false,
    val userModel: UserModel? = null,
    val updatedAge: Int? = null,
) {
    val age = updatedAge ?: userModel?.profile?.age
    val isAgeChanged = updatedAge != null && updatedAge != userModel?.profile?.age
    val isAgeValid = updatedAge == null || updatedAge >= 18
}
